module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/address/secondary_address.js
// module id = 1175
// module chunks = 0